<div class="form-group mb-3" [formGroup]="form">
    <label for="float-input" class=" label-control">{{ field['label'] }}</label>
    <p-inputNumber inputId="integeronly" class="number-input" [formControlName]="field['name']"
        placeholder="{{ field['label'] }}"></p-inputNumber>
</div>